<template>

  <client-form
    v-if="clientFormData"
    :title="title"
    :submit-button-text="submitButtonText"
    :client-form-data="clientFormData"
    @submitClientForm="onSubmit($event)"
  />

</template>

<script>

import router from '@/router'
import store from '@/store'
import i18n from '@/libs/i18n'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

import ClientForm from './ClientForm.vue'

export default {
  components: {
    ClientForm,
  },
  data() {
    return {
      title: i18n.t('client.update.title'),
      submitButtonText: 'Modifier',
      clientFormData: undefined,
    }
  },
  mounted() {
    this.$nextTick(() => {
      const clientId = router.currentRoute.params.id
      store.dispatch('client/fetchClient', clientId)
        .then(response => {
          this.clientFormData = response.data
        })
    })
  },
  setup() {
    const toast = useToast()

    const onSubmit = formValue => store.dispatch('client/updateClient', formValue)
      .then(() => {
        router.push({ name: 'clients-list' })
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: i18n.t('client.update.error'),
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })

    return {
      onSubmit,
    }
  },
}
</script>
